/**
 * Authentication API functions.
 */

import apiClient, { setTokens, clearTokens, setVeToken } from './client';
import type { LoginRequest, TokenResponse, UserDetail } from '@/types';

/**
 * Login with username and password.
 */
export const login = async (credentials: LoginRequest): Promise<TokenResponse> => {
  const response = await apiClient.post<TokenResponse>('/auth/login/', credentials);
  const { access, refresh, keycloak_token } = response.data;
  setTokens(access, refresh);
  // 本地认证账号（如 admin）没有 Keycloak token，此时清掉旧值，避免沿用过期凭据
  setVeToken(keycloak_token);
  return response.data;
};

/**
 * Logout - clear tokens.
 */
export const logout = (): void => {
  clearTokens();
};

/**
 * Get current user info.
 */
export const getCurrentUser = async (): Promise<UserDetail> => {
  const response = await apiClient.get<UserDetail>('/auth/me/');
  return response.data;
};

/**
 * Refresh access token.
 */
export const refreshToken = async (refresh: string): Promise<TokenResponse> => {
  const response = await apiClient.post<TokenResponse>('/auth/refresh/', { refresh });
  const { access, refresh: newRefresh } = response.data;
  setTokens(access, newRefresh);
  return response.data;
};
